import * as gzSpinnerDirective from './spinner.directive';

export default angular.module('gazelle.components.spinner', [])
  .directive(gzSpinnerDirective.name, gzSpinnerDirective.default)
  .name;




// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/spinner/spinner.module.js